module.exports = "https://static.wanderu.com/static/media/refer-a-friend.04cda9c2.svg";